/*
 * @Description:
 * @version:
 * @Author: guyifeng
 * @Date: 2020-09-29 10:17:11
 * @LastEditors: guyifeng
 * @LastEditTime: 2020-10-09 18:09:17
 */
import { DIALOGUE_SERVER, SERVER, TEACHING_SERVER } from '@/constants/servers';
import fetch, { G_DATA } from '@/lib/fetch';
import { queued } from '@/utils/queued';


const API_DICT = {
  pullMessages: `${DIALOGUE_SERVER}/student/message/check`,
  markRead: `${DIALOGUE_SERVER}/message/student/mark_read`,
  sendMessage: `${DIALOGUE_SERVER}/message/student/page_send`,
  pushMassMessage: `${SERVER}/mass_message/push`,
  log: `${DIALOGUE_SERVER}/log`,
};

export function pullMessages(lastMessageId) {
  return fetch(
    API_DICT.pullMessages,
    {
      lastMessageId,
    },
    {
      method: 'post',
    },
  );
}

export function markMsgHasBeenRead(messageOid) {
  return fetch(
    API_DICT.markRead,
    {
      messageOid,
    },
    {
      method: 'post',
    },
  );
}

export function sendMessage(msg) {
  return fetch(API_DICT.sendMessage, msg, {
    method: 'post',
  });
}

/**
 * 记录日志到后台，方便查看出现问题的原因
 * @param {*} payload
 */
export function sendLog(payload) {
  payload.student_id = G_DATA.token.slice(16, 40);
  payload.cookie = document.cookie;

  // file 协议下可能获取不了
  try {
    payload.localStorage = localStorage;
  } catch (e) {
    payload.localStorage = false;
    console.log('不能获取 localStorage');
  }

  const url = `${API_DICT.log}?log=${encodeURIComponent(JSON.stringify(payload))}`;
  return fetch(url, {}, {
    method: 'get',
  });
}

export function pushMassMessage() {
  return fetch(API_DICT.pushMassMessage, {}, {
    method: 'post',
  });
}

export const getServeStatus = () => fetch(`${TEACHING_SERVER}/teacher/service_time`, {}, {
  method: 'post',
});

/**
 * 缓存了的老师的数据
 * @type {Record<string, ITeacherInfo>}
 */
const CACHED_TEACHER_INFO = {};

/**
 * 根据 OID 获取老师的信息
 * @param {string} oid 老师 OID
 * @return {Promise<ITeacherInfo | undefined>}
 */
export const getTeacherInfoByOid = async (oid) => {
  if (CACHED_TEACHER_INFO[oid]) {
    return CACHED_TEACHER_INFO[oid];
  }
  return CACHED_TEACHER_INFO[oid] = await queued(oid, () => fetch(`${SERVER}/teacher/info`, {
    teacherOid: oid,
  }, {
    method: 'post',
  }));
};
